module.exports = [
  'Ambiguous genitalia / sex development',
  'Bedwetting (nocturnal enuresis)',
  'Bladder exstrophy and epispadias',
  'Bladder, testicular, and kidney cancers',
  'Cloacal deformities',
  'Cystic disease of the kidney',
  'Disorders of sexual development',
  'Duplex kidneys and ureters',
  'Elimination disorders: encopresis and enuresis (voiding dysfunction and urinary incontinence)',
  'Fetal anomalies of the urinary tract, kidneys or reproductive organs',
  'Genital reconstruction surgery',
  'Hematuria',
  'Hernia and hydroceles',
  'Horseshoe kidney or pelvic kidney',
  'Hydronephrosis and obstruction of the urinary tract',
  'Hypospadias',
  'Kidney stones',
  'Neurogenic bladder including spinal cord injury and spina bifida',
  'Phimosis',
  'Posterior urethral valves',
  'Testicular torsion',
  'Undescended testicles',
  'Urinary tract infection',
  'Varicocele',
  'Vesicoureteral reflux (VUR)',
];



// WEBPACK FOOTER //
// ./src/data/conditions.js